export default __webpack_public_path__ + "static/media/yin.3d0a1b0b.jpg";